var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{staticClass:"mx-auto",class:{'container-lg px-1 py-4': !_vm.fullWidth}})}
var staticRenderFns = []

export { render, staticRenderFns }